    

<style>
    .k-item.k-state-selected.k-state-focused:not(:hover) {
        background-color: transparent;
        color: inherit;
    }    
</style>



<div *ngIf="showDashboard">
    <div [hidden]="!showList">
        <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="card">
                        <div class="inv-header-box">
                            <h4 class="card-title m-b-5 h4"> OPEN INVOICES</h4>
                        </div>
                        <div class="card-body chart-wrapper">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="card">
                                            <div class="card-body opens"  (click)="onClickinvoice('open')">
                                                <div class="d-flex">
                                                    <div class="m-r-20 align-self-center icon-invoices-container">
                                                    <span>
                                                        <img src="assets/icons/open-invoice-icon-colored.svg" class="icon-invoices-status" >
                                                    </span>
                                                    <p >{{selectedItem?.Code==='Currency'?'':selectedItem?.Code}}</p>
                                                    </div>
                                                    <div class="stats-icon text-left ">   
                                                        <div>
                                                            <span class="no-of-inv">{{dashboard?.NoOpenInvoices |  number: 0}}</span> <span class="no-of-inv-text">invoices</span>
                                                            <span class="no-of-total-text">{{ dashboard?.OpenInvoicesValue | moneySuffix: 2  }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="static-text"> All Open and In Progress Invoices</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card" >
                                            <div class="card-body webress" (click)="onClickinvoice('webres')" >
                                                <div class="d-flex">
                                                    <div class="m-r-20 align-self-center icon-invoices-container">
                                                        <span>
                                                            <img src="assets/icons/web-res-invoice-icon-colored.svg" class="icon-invoices-status" >
                                                        </span>
                                                    <p >{{selectedItem?.Code==='Currency'?'':selectedItem?.Code}}</p>
                                                    </div>
                                                    <div class="stats-icon text-left">
                                                        <div >
                                                            <span class="no-of-inv">{{dashboard?.NoInvoicesRequiring |  number: 0}}</span> 
                                                            <span class="no-of-inv-text">invoices</span>
                                                            <span class="no-of-total-text">{{ dashboard?.RequiringInvoicesValue | moneySuffix: 2 }}</span>                                                             
                                                        </div>
                                                    </div>                                       
                                                </div>
                                                <div class="text-left-icon">
                                                    <span class="static-text"> Invoices that require your action in  web resolution</span>
                                                </div>
    
                                                <span >
                                                    <button class="gotowebres" (click)="onClickWebresolution()"><img src="../../assets/icons/return-icon.svg" style="height: 14px;margin-right: 5px;"> Go to WR</button>
                                                </span>
                                            </div>
                                        </div>
                                
                                    </div>
                                </div>
                        
                                <div style="height:250px" >  
                                    <div class="row">
                                        <div class="col-md-9" style="margin-top: -15px;">
                                            <div style="text-align: center;margin-left: 16%;">
                                                <span class="over-current-due">CURRENT</span>
                                                <span class="due-date">DUE DATE</span>
                                                <span class="over-current-due">OVER DUE</span>
                                            </div>
                                            <div nz-row class="open-chart-height">
                                                <canvas *ngIf="dashboard?.BarOpenInvoice?.length"
                                                    baseChart 
                                                    #chart="base-chart"
                                                    [datasets]="dashboard.BarSelected" 
                                                    [options]="barOpenInvoiceChartOptions"
                                                    [labels]="barOpenInvoiceChartLabels"

                                                    [chartType]="barOpenInvoiceChartType"
                                                    [colors]="barOpenInvoiceChartColors"                                   
                                                    (chartClick)="openClicked($event)">
                                                </canvas>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                        
                                            <div class="form-group" style="margin-top: -14px;" >
                                                <kendo-dropdownlist class="custom-size" 
                                                    [data]="chartFormatType"
                                                    (valueChange)="formatchangeKendo($event)"
                                                    [textField]="'data' " 
                                                    [valueField]="'index'"
                                                    [(ngModel)]="selectedFormatValue"
                                                ></kendo-dropdownlist>
                                            </div>
                                            <div style="position: absolute;bottom: 0;right: 0;">
                                                <div *ngFor="let st of dashboard?.BarSelected; let i = index" >
                                                    <div class="status-wrapper ">
                                                        <span class="open-legend" 
                                                            [ngClass]="{
                                                                'inweb': st.label === 'IN WEB RESOLUTION' ,
                                                                'myweb': st.label === 'MY WEB RESOLUTION' ,
                                                                'inprog': st.label === 'IN PROGRESS',
                                                                'passedawait': st.label === 'PASSED-AWAITING PRODUCTION',
                                                                'rejectawait': st.label === 'REJECTED-AWAITING PRODUCTION'  
                                                            }">{{ st.label | uppercase }}</span>
                                                        <app-checkbox [class]="'open' + i" [id]="i" [(ngModel)]="!st.hidden" (ngModelChange)="checkBoxLabelOpenInvoiceChange(i)"></app-checkbox> 
                                                    </div>
                                                </div>
                                            </div>
                                    
                                        </div>
                                    </div>        
                                </div>                   
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="card">
                        <div class="inv-header-box" >

                            <ng-container *ngIf="this.dashboardForm != null ">
                                <div class="select-period" [formGroup]="dashboardForm">
                                    <nz-select class="custom-size no-border" nzShowSearch ngDefaultControl formControlName="datePeriod" nzPlaceHolder="Date Period" (ngModelChange)="onDataHistoryClick($event)" >
                                        <nz-option *ngFor="let list of dataHistory" [nzValue]="list .CodeName" [nzLabel]="list.Name" style="width: 150px;"></nz-option>
                                    </nz-select>
                                </div>
                            </ng-container>

                            <h4 class="card-title m-b-5 h4"> CLOSED INVOICES</h4>                            
                        </div>
                        <div class="card-body chart-wrapper">
                            <div class="row title" style="margin-bottom:0">
                            </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="card" >
                                            <div class="card-body passed" (click)="onClickinvoice('pass')">
                                                <div class="d-flex">
                                                    <div class="m-r-20 align-self-center icon-invoices-container">
                                                        <span>
                                                            <img src="assets/icons/passed-invoice-icon-colored.svg" class="icon-invoices-status" >
                                                        </span>
                                                        <p >{{selectedItem?.Code==='Currency'?'':selectedItem?.Code}}</p>
                                                    </div>
                                                    <div class="stats-icon text-left " >
                                                        <div>
                                                            <span class="no-of-inv">{{dashboard?.NoInvoicesPassed |  number: 0}}</span> <span class="no-of-inv-text">invoices</span>
                                                            <span class="no-of-total-text">{{ dashboard?.PassedInvoicesValue | moneySuffix: 2  }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="static-text"> Passed Invoices</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card" >
                                            <div class="card-body rejected" (click)="onClickinvoice('reject')">
                                                <div class="d-flex">
                                                    <div class="m-r-20 align-self-center icon-invoices-container">
                                                        <img src="assets/icons/rejected-invoice-icon-colored.svg" class="icon-invoices-status" >
                                                        <p>{{selectedItem?.Code==='Currency'?'':selectedItem?.Code}}</p>
                                                    </div>
                                                    <div class="stats-icon text-left">
                                        
                                                        <div>
                                                            <span class="no-of-inv">{{dashboard?.NoInvoicesRejected |  number: 0}} </span> <span class="no-of-inv-text">invoices</span>
                                                            <span class="no-of-total-text">{{ dashboard?.RejectedInvoicesValue | moneySuffix: 2  }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span  class="static-text">Rejected Invoices</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <div style="height:250px">

                                <div nz-row class="status-options" style="margin-bottom: -20px;margin-left: 25%;margin-top: -5px;">
                                    <div *ngFor="let st of dashboard?.barChartData; let i = index">
                                        <div class="status-wrapper">
                                            <app-checkbox [class]="'invoice' + i" [id]="'invoice' + i" [(ngModel)]="!st.hidden" (ngModelChange)="checkBoxLabelInvoiceHistoryChange(st)"></app-checkbox> <span style="font-size: 10px;font-weight: 600;" [ngClass]="{'rejectedlabel': st.label === 'Rejected','passedlabel': st.label === 'Passed'  }">{{ st.label | uppercase }}</span>
                                        </div>
                                    </div>
                                
                                    <div style="display: flex;width: 150px;float: right;margin-left: 100px;margin-right: -50px;">
                                        <kendo-dropdownlist  class="custom-size" [data]="chartFormatType"
                                            (valueChange)="formatchangeKendo($event)"
                                            [textField]="'data'" 
                                            [valueField]="'index'"
                                            [(ngModel)]="selectedFormatValue"
                                        ></kendo-dropdownlist>
                                    </div>
                                </div>

                                <div nz-row style="height:85%;" >
                                    <canvas 
                                        baseChart *ngIf="dashboard != null"
                                        #invoiceHistoryChart="base-chart"
                                        [datasets]="dashboard.barChartData" 
                                        [options]="barChartOptions" 
                                        [labels]="barchartlabels"  
                                       
                                        [chartType]="barChartType"
                                        [colors]="barChartColors"
                                        (chartClick)="closedInvoiceChartClick($event)">
                                    </canvas>
                                </div>
                            
                            </div>
                            
                        </div>
                    </div>
                </div>
        </div>
    
        <!-- Grid Here.. -->
        <div>
            <div >
                <div>
                    <div class="row-parent white-bg filter-all-container">
    
                        <div>
                            <div class="btn-flex-wrapper">
                                   
                                    <div class="select-all-wrapper">
                                        <div class="roundcheckbox-dashboard align-checkbox">
                                            <input type="checkbox" id="checkbox" [(ngModel)]="checked" (ngModelChange)="checkBoxSelectAll($event)" />
                                            <label for="checkbox"></label>
                                        </div>
                                        <span class="select-all-checkbox">Select All</span>
                                    </div>
                                    
                                    <button [ngStyle]="exportStyle" nz-button nzType="default" [class.hasSelected]="false" nz-tooltip nzTooltipTitle="Export Data" (click)="exportData()"> 
                                        <img src="assets/icons/export-icon-15x15.svg" [ngStyle]="exportStyleIcon">Export Data
                                    </button>
                                    
                                    <button   nz-button nzType="default"  nz-tooltip nzTooltipTitle="Clear Filters" (click)="clearFilter()">
                                        <img src="assets/icons/clear-icon-15x15.svg" >Clear Filters
                                    </button>
    
                                    <button nz-button nzType="default" [class.hasSelected]="false" nz-tooltip nzTooltipTitle="Refresh" (click)="refreshData()">
                                        <img src="assets/icons/refresh-icon-15x15.svg">Refresh
                                    </button>
                            
                                    <div class="btn-group" >
                                        <kendo-dropdownlist class="custom-size-display" [data]="displayList"
                                            (valueChange)="selectionDisplay($event)"
                                            [textField]="'Name'" 
                                            [valueField]="'Code'"
                                            [(ngModel)]="selectedTempValue">
                                        </kendo-dropdownlist>
                                    </div>
                            </div>
                        </div>
    
                        <div class="filter-container-main" >


                                  <drag-scroll [scrollbar-hidden]="false">
                                    
                                        <div drag-scroll-item *ngFor="let filter of listFilterInvNos" class="filter-dashboard-wrapper">
                                            <span>{{ filter  }}</span>
                                            <span class="close"  (click)="onCloseInvoiceNos(filter, $event)"></span>
                                        </div>

                                        <ng-container *ngFor="let filter of dashboard?.BarSelected" >
                                            <div *ngIf="!filter.hidden" drag-scroll-item [ngClass]="{
                                                                'inweb-filter': filter.label === 'IN WEB RESOLUTION' ,
                                                                'myweb-filter': filter.label === 'MY WEB RESOLUTION' ,
                                                                'inprog-filter': filter.label === 'IN PROGRESS',
                                                                'passedawait-filter': filter.label === 'PASSED-AWAITING PRODUCTION',
                                                                'rejectawait-filter': filter.label === 'REJECTED-AWAITING PRODUCTION'  
                                                            }" class="filter-dashboard-wrapper">
                                                <span>{{ filter.label  }}</span>
                                                <span class="close" (click)="onCloseFilter(filter, $event)"></span>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngFor="let filter of dashboard?.barChartData" >
                                            <div *ngIf="!filter.hidden" drag-scroll-item [ngClass]="{
                                                                        'passedawait-filter': filter.label === 'PASSED',
                                                                        'rejectawait-filter': filter.label === 'REJECTED'  
                                                                    }" class="filter-dashboard-wrapper">
                                                <span>{{ filter.label  }}</span>
                                                <span class="close" (click)="onCloseFilterClosedInvoices(filter)"></span>
                                            </div>
                                        </ng-container>

                                        <!-- <div drag-scroll-item *ngFor="let filter of listFilterOpenGraph" class="filter-dashboard-wrapper">
                                            <span>{{ filter.Name  }}</span>
                                            <span class="close"  (click)="onCloseFilterGraph(filter, $event)"></span>
                                        </div> -->
            
                                        <!-- <div drag-scroll-item *ngFor="let filter of listFilterCloseGraph" class="filter-dashboard-wrapper">
                                            <span>{{ filter.Name  }}</span>
                                            <span class="close"  (click)="onCloseFilterCloseGraph(filter, $event)"></span>
                                        </div>            -->

                                </drag-scroll>                                
                   
                        </div>
                        
                        <div >
                            <div class="starter-search-container" >

                                <div class="btn-group starter-search-element"> 
                                    <app-search (dataOut)="dataOut($event)" [client]="dashboardForm.get('client').value" [appmodule]="appmodule"></app-search>
                                </div>

                                <div class="btn-group" > 
                                    <kendo-dropdownlist class="custom-size-filter" [data]="invSortDropDownList"
                                    (valueChange)="selectionChangeInvSort($event)"
                                    [textField]="'Name' " 
                                    [valueField]="'Code'"
                                    [(ngModel)]="selectedItemInvSortCopy"
                                    >
                                    </kendo-dropdownlist>
                                </div>
                                <span class="asc"(click)="changeSortingAsc()" *ngIf="isVisible" style="margin-top: -1px;"><img src="../../assets/icons/sort-asc.png" style="width:20px;" alt=""></span>
                                <span class="desc" (click)="changeSortingDesc()" *ngIf="!isVisible" style="margin-top: -1px;"><img src="../../assets/icons/sort-desc.png" style="width:20px;" alt=""></span>                            
                            </div>
                        </div>
    
                    </div>
                </div>
                    <div class="dp2table">
                        <div *ngIf="selectedDisplay == 'display2'" class="col-md-12">

                            <div *ngFor="let inv of invoicesList  | paginate: { id: 'server', itemsPerPage: ngxConfig.itemsPerPage, currentPage: grid2PageNo, totalItems: ngxConfig.totalItems } ; index as rowIndex">
                                <div class="ctgf-grid-mbb">
                                    <div class="card">
                                        <div class="display2-container-lvl1" >
                                            <div class="btn-group btn-group-justified">
                                                <div  class="grid-ctgf-btn-view" style="margin-top: 1px;">
                                                    <div class="lobo" >
                                                        <input type="checkbox" [id]="'checkbox' + rowIndex"  name="invoice" [(ngModel)]= "inv.IsChecked" (ngModelChange)="checkBoxChanges($event, inv)" >
                                                        <label [for]="'checkbox' + rowIndex"></label>
                                                    </div>
                                                    
                                                </div>
                                                <div  class="grid-ctgf-web-r-pm" >
                                                </div>
                                                <div class="grid-ctgf-top" >
                                                    <h5 class="grid-ctgf-web-r-code">{{inv?.ResolutionReasonCode}}</h5>
                                                    <div class="grid-ctgf-top-right-fjl">
                                                        <span [ngClass]="{'rejected_status': inv?.Status === '112','passed_status': inv?.Status === '108','passed-awaiting-status' : inv?.Status === '103' , 'rejected-awaiting-status': inv?.Status === '104', 'inWeb_status': inv?.Status === '106', 'inprog_status': containsOpen(inv.Status)  }">{{ inv?.StatusName }}</span>
                                                    ​</div>
                                                </div>
                                                
                                                <div class="mr-auto h4 grid-ctgf-top" style="width: 500px;">
                                                    <div class="ctgf-grid-inv-rDescs">{{inv?.ResolutionDescription}}
                                                        <span class="tooltiptext-inv-rDesc" *ngIf="inv?.ResolutionDescription?.length >= 57">​{{inv?.ResolutionDescription}}</span>
                                                    </div>
                                                    <div class="parentCell-rDesc">​{{inv?.Comments}}
                                                        <span class="tooltiptext" *ngIf="inv?.Comments?.length >= 75">​{{inv?.Comments}}</span>
                                                    </div>
                                                </div>
                                                <div  class="grid-ctgf-top">
                                                    <h6 class="grid-ctgf-top-right" >​Rate File Name: </h6>
                                                    <div class="grid-ctgf-top-right-fjlr">{{inv?.RateFileName}}
                                                        <span class="tooltiptext-inv-fjlr" >​{{inv?.RateFileName}}</span>
                                                    </div>
                                                </div>
                                                <div class="grid-ctgf-top">
                                                    <h6 class="grid-ctgf-top-right" >Current Status (days)</h6>
                                                    <h5 class="grid-ctgf-top-right-fjl" >{{inv?.DaysInResolution}}</h5>
                                                </div>
                                                <div class="grid-ctgf-top">
                                                    <h6 class="grid-ctgf-top-right">​Days to Due Date</h6>
                                                    <h5 class="grid-ctgf-top-right-fjl" >{{inv?.DaysToDueDate}}</h5>
                                                </div>
                        
                                                <div class="grid-ctgf-top">
                                                    <h6 class="grid-ctgf-top-right" >Times in Web Resolution</h6>
                                                    <h5 class="grid-ctgf-top-right-fjl" >{{inv?.NumberOfTimesInResolution}}</h5>
                                                </div>
                                                <div class="grid-ctgf-top">
                                                    <h6 class="grid-ctgf-top-right" >Shipments</h6>
                                                    <h5 class="grid-ctgf-top-right-fjl" >{{inv?.NoOfShipment}}</h5>
                                                </div>
                                            </div>
                                            <div style="display: flex;" >
                                                <div class="dp2table-icon-view">
                                                    <div class="grid-ctgf-tbody-td-icon" style="display: flex;">
                                                <a (click)="openInvoice(inv.invoiceFile,inv.Id)" ><img src="../../assets/icons/pdf-icon-25x25.svg" style="width:25px;filter: invert(27%) sepia(56%) saturate(5%) hue-rotate( 
                                                        174deg) brightness(106%) contrast(90%);margin: 5px;" alt=""></a>
                                                    <a (click)="openDownload(inv.Id)"><img src="../../assets/icons/xls-icon-25x25.svg" style="width:25px;filter: invert(27%) sepia(56%) saturate(5%) hue-rotate( 
                                                        174deg) brightness(106%) contrast(90%);margin: 5px;" alt=""></a>
                                                    </div>
                                                    <button  *ngIf="UserType != 'Carrier'"  class="freight-primary grid-btn" (click)="viewClickDisplay1(inv?.Id)" style="margin-left: 7px;margin-top: 5px;">
                                                        View
                                                    </button>
                                                </div>
                                                <div class="dp2table-w">
                                                    <div class="dp2table-data-infos">
                                                            <tbody class="grid-ctgf-tbody-p">
                                                                <tr class="grid-ctgf-tbody-p" style="  border-collapse: collapse;
                                                                border-spacing: 0;
                                                                width: 10%;
                                                                border: 1px solid #ddd;">
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Invoice Number</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Invoice Date</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Due Date</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Client</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 150px !important;margin-bottom: 15px">Carrier</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Currency</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Invoice Amount</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Mode</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Service</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Origin</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Destination</h6></th>
                                                                    <th><h6 class="grid-ctgf-tbody-th" style="width: 120px !important;margin-bottom: 15px">Reason Code</h6></th>
                                                                </tr>
                                                                <tr  class="grid-ctgf-tbody-p">
        
                                                
                                                                    <td class="grid-ctgf-tbody-td" ><div class="grid-ctgf-tbody-td-invno" style="width: 120px !important;margin-bottom: 5px;">{{inv?.InvoiceNo}} <span class="tooltiptext-inv-invno">​{{inv?.InvoiceNo}}</span></div></td>
                                                                    <td class="grid-ctgf-tbody-td" ><h5 class="grid-ctgf-tbody-td-dtl" style="width: 120px !important;margin-bottom: 5px;">{{inv?.InvoiceDate | date: 'dd/MMM/yyyy'}}</h5></td>
                                                                    <td class="grid-ctgf-tbody-td" ><h5 class="grid-ctgf-tbody-td-dtl" style="width: 120px !important;margin-bottom: 5px;">{{inv?.DueDate | date: 'dd/MMM/yyyy'}}</h5></td>
                                                                    <td class="grid-ctgf-tbody-td" ><h5 class="grid-ctgf-tbody-td-dtl" style="width: 120px !important;margin-bottom: 5px;">{{inv?.ClientCode}}</h5></td>
                                                                    <td class="grid-ctgf-tbody-td" ><div class="grid-ctgf-tbody-td-Carrier" style="width: 150px !important;margin-bottom: 5px;">{{inv?.CarrierName}}<span class="tooltiptext-inv-Carrier">​{{inv?.CarrierName}}</span></div> </td>
                                                                    <td class="grid-ctgf-tbody-td" ><h5 class="grid-ctgf-tbody-td-dtl" style="width: 120px !important;margin-bottom: 5px;">{{inv?.Currency}}</h5></td>
                                                                    <td class="grid-ctgf-tbody-td" ><h5 class="grid-ctgf-tbody-td-dtl" style="width: 120px !important;margin-bottom: 5px;">{{inv?.BilledAmount | number:'1.0-0':'en-US' }}</h5></td>
                                                                    <td class="grid-ctgf-tbody-td" ><h5 class="grid-ctgf-tbody-td-dtl" style="width: 120px !important;margin-bottom: 5px;">{{inv?.ShipmentMode}}</h5></td>
                                                                    <td class="grid-ctgf-tbody-td" ><div class="grid-ctgf-tbody-td-dtl1" style="width: 120px !important;margin-bottom: 5px;">{{inv?.ServiceLevel}} <span class="tooltiptext-inv-td1">​{{inv?.ServiceLevel}}</span></div> </td>
                                                                    <td class="grid-ctgf-tbody-td" ><div class="grid-ctgf-tbody-td-Origin" style="width: 120px !important;margin-bottom: 5px;">{{ inv?.OriginCountryCode}}<span class="tooltiptext-inv-Origin">​{{inv?.OriginCountryCode}}</span></div></td>
                                                                    <td class="grid-ctgf-tbody-td" ><div class="grid-ctgf-tbody-td-DC" style="width: 120px !important;margin-bottom: 5px;">{{ inv?.DestinationCountryCode}}<span class="tooltiptext-inv-DC">​{{inv?.DestinationCountryCode}}</span></div></td>
                                                                    <td class="grid-ctgf-tbody-td" ><h5 class="grid-ctgf-tbody-td-dtl" style="width: 120px !important;margin-bottom: 5px;">{{inv?.ResolutionReasonCode}}</h5></td> 
                                                                </tr> 
                                                            </tbody>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="card-body table-responsive" style="display: flex;">
    
                                <pagination-controls id="server" (pageChange)="onChangePage2($event)"></pagination-controls>
    
                                <select class="custom-select"  (change)="setItemsPerPage(page.value)"  #page style="width: 100px;
                                    height: 25px;
                                    font-size: 11px;
                                    padding: 1px 0px 0px 5px;
                                    font-weight: 600;
                                    font-family: 'Roboto';">
                                    <option selected>10</option>
                                    <option >20</option>
                                    <option >50</option>
                                    <option >100</option>
                                    <option >300</option>
                                    <option >All</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div  *ngIf="selectedDisplay == 'display1'" class="kendogrid" style="background: #fff;padding: 5px 15px;z-index: 9999;margin-top: -1px;">
                        <kendo-grid 
                            class="dashboard-grid"
                            [data]="invsDataGrid"
                            [skip]="skip"
                            [pageable]="{ pageSizes: pageSizes}"
                            [height]="410" 
                            [pageSize]="pageSize" 
                            scrollable="scrollable"
                            [reorderable]="true"
                            [sortable]="true"
                            [sort]="sort"
                            (sortChange)="sortChange($event)"
                            [pageable]="true" 
                            [resizable]="true"
                            [columnMenu]="{ filter: false }"
                            (pageChange)="pageChange($event, grid)"
                            (edit)="onClickinvoice1($event)">
    
                        <kendo-grid-column [width]="360" [locked]="true"  [headerStyle]="{'background-color': '#103f6f',color: '#103f6f'}"[columnMenu]="true">
            
                            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                <div class="option-controls" style="display: flex;">      
                                    <button  *ngIf="UserType != 'Carrier'"   class="freight-primary grid-btn" (click)="onClickinvoice1(dataItem)">View</button>                          
                                    <span class="grid-ctgf-tbody-td-dld">
                                            <div class="checkbox-container">
                                                <div class="lobo">
                                                    <input type="checkbox" [(ngModel)]="dataItem.IsChecked" [id]="'checkbox' + rowIndex"  (ngModelChange)="checkBoxChanges($event, dataItem)" />
                                                    <label [for]="'checkbox' + rowIndex"></label>
                                                </div>
                                            </div>
                                    </span> 
                                    <a  (click)="openInvoice(dataItem)"><img src="../../assets/icons/pdf-icon-25x25.svg" style="width:20px;filter: invert(27%) sepia(56%) saturate(5%) hue-rotate( 
                                        174deg) brightness(106%) contrast(90%);margin-top: 2px;" alt=""></a>
                                    <a (click)="openDownload(dataItem.Id)"><img src="../../assets/icons/xls-icon-25x25.svg" style="width:20px;filter: invert(27%) sepia(56%) saturate(5%) hue-rotate( 
                                        174deg) brightness(106%) contrast(90%);margin-top: 2px;" alt=""></a>
                                    <span [ngClass]="{'rejected_status': dataItem.Status === 112,'passed_status': dataItem.Status === 108,'passed-awaiting-status' : dataItem.Status === 103 , 'rejected-awaiting-status': dataItem.Status === 104, 'inWeb_status': dataItem.Status === 106, 'inprog_status': containsOpen(dataItem.Status)  }">{{ dataItem.StatusName }}</span>
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        
                        <kendo-grid-column field="InvoiceNo" title="Invoice Number" [width]="120" [columnMenu]="false" [headerStyle]="headerStyle" [filterable]="true" >
                        </kendo-grid-column>
                
                        <kendo-grid-column field="NoOfShipment" title="Shipments" [width]="120" [columnMenu]="false" [headerStyle]="headerStyle">
                            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                <span>Shipments</span>
                            </ng-template>
                        </kendo-grid-column>
                
                        <kendo-grid-column field="InvoiceDate" width="100" title="Invoice Date" [columnMenu]="false" [headerStyle]="headerStyle">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.InvoiceDate | date: 'dd/MMM/yyyy'}}
                            </ng-template>
                        </kendo-grid-column>
                
                        <kendo-grid-column field="DueDate" width="100" title="Due Date" [columnMenu]="false" [headerStyle]="headerStyle">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.DueDate | date: 'dd/MMM/yyyy'}}
                            </ng-template>
                        </kendo-grid-column>
                
                        <kendo-grid-column field="ClientCode" title="Client" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="ClientRegion" title="Client Region" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>                    
                        
                        <kendo-grid-column field="ClientCountry" title="Client Country" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="ClientCity" title="Client City" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="ClientDivision" title="Client Division" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="ClientLocation" title="Client Location" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="CarrierCode" title="Carrier SCAC" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="CarrierName" title="Carrier Name" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                        
                        <kendo-grid-column field="CarrierCity" title="Carrier City" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                        
                        <kendo-grid-column field="CarrierCountry" title="Carrier Country" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="Currency" title="Currency" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column  format={0:n2} field="BilledAmount" title="Invoice Amount" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                        
                        <kendo-grid-column field="ShipmentMode" title="Mode" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                        
                        <kendo-grid-column field="ServiceLevel" title="Service" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="OriginCountryCode" title="Origin" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="DestinationCountryCode" title="Destination" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                
                        <kendo-grid-column field="ResolutionReasonCode" title="Reason Code" width="100" [columnMenu]="false" [headerStyle]="headerStyle">
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
    
    </div>
    
    <div [hidden]="showList"  >
        <div class="detail-container-wrapper" >
            <div class="top-header">
    
                <button class="freight-primary" (click)="onClicksummary()">Back<img class="back-btn-details" src="../../assets/icons/return-icon.svg"></button>
                
                <div class="pt-status">
                    <div>
                        <div> <span [ngClass]="{'rejected_status': inv?.StatusID === 112,'passed_status': inv?.StatusID === 108,'passed-awaiting-status' : inv?.StatusID === 103 , 'rejected-awaiting-status': inv?.StatusID === 104, 'inWeb_status': inv?.StatusID === 106, 'inprog_status': containsOpen(inv?.StatusID)}">{{ inv?.Status }}</span></div>
                    </div>
                </div>
    
                <div class="pt-status">
                    <div>
                        <div>DAYS IN CURRENT STATUS</div>
                        <div class="status-color">{{ inv?.DaysInResolution }}</div>
                    </div>
                </div>
                <div class="pt-status">
                    <div>
                        <div>​Days to Due Date</div>
                        <div class="due-color">{{inv?.DaysToDueDate }}</div>
                    </div>
                </div>
                <div class="pt-status">
                    <div>
                        <div>CURRENT ACTION OWNER</div>
                        <div>{{ allocation }}</div>
                    </div>
                </div>
                
                <div class="doc-controls">
                    <button class="freight-primary"  (click)="viewAttachDocument(inv?.Id)">View Attachments</button>
                    <button class="freight-primary"  (click)="attachDocument()">Add Attachments</button>
                </div>
            
            </div>   
        <kendo-splitter orientation="horizontal" style="height: 100vh;border:0" >
            <kendo-splitter-pane size="50%">
                <div class="details-container" >
                    <div nz-row nzGutter="8">
                        <div nz-col nzSpan="12">
                            <div class="client-profile">
                                <img src="../../assets/icons/client-icon-50x50.svg" alt="" >
                                <div class="cp-details">
                                    <div class="cp-details-title">CLIENT PROFILE</div>
                                    <div class="cp-details-name">{{inv?.Client?.Name}} </div>
                                    <div class="cp-details-location">{{inv?.Client?.Country}} {{inv?.Client?.City}}</div>
                                    <div class="cp-details-address">{{(inv?.Client?.Address1)?inv?.Client?.Address1:inv?.Client?.Address2}}</div>
                                </div>
                            </div>
                        </div>
        
                        <div nz-col nzSpan="12">
                            <div class="client-profile">
                                <img src="../../assets/icons/carreer-icon-50x50.svg" alt="" >
                                <div class="cp-details">
                                    <div class="cp-details-title">CARRIER PROFILE</div>
                                    <div class="cp-details-name">{{ inv?.Carrier?.Name }}</div>
                                    <div class="cp-details-location">{{inv?.Carrier?.Country}} {{inv?.Carrier?.City}}</div>
                                    <div class="cp-details-address">{{(inv?.Carrier?.Address1)?inv?.Carrier?.Address1:inv?.Carrier?.Address2}}</div>
                                </div>
                            </div>
                        </div>
                    </div> 
    
                    
                 <div nz-row class="infos">
                    <div class="folder-bg">
                      <h4 class="tab">INVOICE INFORMATION</h4>
                    </div>                  
                    <div class="cp-bg-white">
                      <table class="table wl-table-m">
                          <thead class="wl-thead-b">
                            <tr>
                              <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h">Invoice Number</h6></th>
                              <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h">Invoice Date</h6></th>
                              <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h">Due Date</h6></th>
                              <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h">Currency</h6></th>
                              <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h">Invoice Amount</h6></th>
                              <th class="ctgf-tbl-inv-tr-th"> <h6 class="ctgf-tbl-inv-tr-th-h">Rated Amount</h6></th>
                            </tr>
                          </thead>
                            <tbody>
                              <tr>
                                  <td class="ctgf-tbl-inv-tr-td-h5">{{inv?.InvoiceNo}}</td>
                                  <td class="ctgf-tbl-inv-tr-td-h5">{{inv?.InvoiceDate| date: 'dd/MMM/yyyy'}}</td>
                                  <td class="ctgf-tbl-inv-tr-td-h5">{{inv?.DueDate| date: 'dd/MMM/yyyy'}}</td>
                                  <td class="ctgf-tbl-inv-tr-td-h5">{{inv?.Currency}}</td>
                                  <td class="ctgf-tbl-inv-tr-td-h5">{{inv?.BilledAmount  | number : '1.2-2' }}</td>
                                  <td class="ctgf-tbl-inv-tr-td-h5"></td>
                              </tr> 
                          </tbody>
                    </table>
                    </div>
                        <div class="btn-list">
                        </div>
                        <div nz-row class="infos" >
                            <h4 class="tabExcept">
                              <span  *ngIf="isCollapsedException" (click)="isCollapsedException = !isCollapsedException" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseException" ><i class="mdi mdi-plus" style="font-weight: bold;cursor: pointer;"></i></span>
                              <span   *ngIf="!isCollapsedException" (click)="isCollapsedException = !isCollapsedException" [attr.aria-expanded]="!isCollapsedException" aria-controls="collapseException"><i class="mdi mdi-minus" style="font-weight: bold;cursor: pointer;"></i></span>
                              EXCEPTION INFORMATION
                           </h4>
                          <div id="collapseException" [ngbCollapse]="isCollapsedException" class="tabExceptContent">
                      
                              <div class="info-list-2">   
                                  <div class="info-wrapper" >
                                      <div class="title-header">Reason Code :</div>
                                      <div class="content">
                                          <div>{{inv?.ResolutionReasonCode}}</div>
                                      </div>
                                  </div>
                                  <div class="info-wrapper">
                                      <div class="title-header">Reason Code Description :</div>
                                      <div class="content">
                                          <div>{{inv?.ResolutionDescription}}</div>
                                      </div>
                                  </div>
                                  <div class="info-wrapper">
                                      <div class="title-header">Auditors Remarks :</div>
                                      <div class="content">
                                          <div>{{inv?.ResolutionAuditorsRemarks}}</div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div id="collapseException" [ngbCollapse]="isCollapsedException" class="tabExceptContent">
                            <h4 class="tabExcept" >
                              <span  *ngIf="isCollapsedExceptionComments" (click)="isCollapsedExceptionComments = !isCollapsedExceptionComments" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExceptionComments" ><i class="mdi mdi-plus" style="font-weight: bold;cursor: pointer;"></i></span>
                              <span   *ngIf="!isCollapsedExceptionComments" (click)="isCollapsedExceptionComments = !isCollapsedExceptionComments" [attr.aria-expanded]="!isCollapsedException" aria-controls="collapseExceptionComments"><i class="mdi mdi-minus" style="font-weight: bold;cursor: pointer;"></i></span>
                              COMMENTS
                            </h4>
                            <div id="collapseExceptionComments" [ngbCollapse]="isCollapsedExceptionComments" class="tabExceptContent-Content">
                              <div class="info-list-2" *ngIf="inv?.LatestComments" style="border: none;">
                                  <div class="info-wrapper">
                                      <div class="title-header">
                                          {{inv?.LatestComments?.userCompany}}
                                      </div>
                                      <div class="content">
                                          <div style="font-size: 14px;">
                                              {{inv?.LatestComments?.userFirstName}}   {{inv?.LatestComments?.userinitial}} <span>{{inv?.LatestComments?.posteDate | date: 'dd/MMM/yyyy'}}</span>
                                          </div>
                                          <div [innerHTML]="inv?.LatestComments?.userMessage"></div>
                                      </div>
                                  </div>
                                  <div>
                                    <p style="padding: 1px 1px 10px 1px;font-size: 12px;font-family: 'Roboto';">POST YOUR COMMENT</p>
                                    <textarea rows="4" nz-input [(ngModel)]="comment" placeholder="Comment here..." style="background: #d6d6d6;box-shadow: inset 0px 0px 5px 2px #c9c9c9;"></textarea>
                                  </div>
                              </div>
                              <div class="btn-list" style="margin-bottom: 5px;">
                                <button nz-button nzType="default" class="freight-primary" *ngIf="UserType == 'Client' || UserType == 'CTGF'"   (click)="sendToCarrier()" style="border-radius: 0px;margin: 1px;font-size: 14px;">Send To Carrier</button>
                                <button nz-button nzType="default" class="freight-primary" *ngIf="UserType == 'Carrier' "  (click)="sendToClient()" style="border-radius: 0px;margin: 1px;font-size: 14px;">Send To Client</button>
                                <button nz-button nzType="default" class="freight-primary" (click)="sendCTGlobal()" style="border-radius: 0px;margin: 1px;font-size: 14px;">Send To Ct Global</button>
                                <button nz-button nzType="default" class="freight-primary" (click)="onApprove()" *ngIf="Approved" style="border-radius: 0px;margin: 1px;font-size: 14px;">Approve Invoice</button>
                                <button nz-button nzType="default" class="freight-primary" (click)="onReject()"  *ngIf="Approved" style="border-radius: 0px;margin: 1px;font-size: 14px;">Reject Invoice</button>
                            </div>
                              <!-- <span class="gotoBottom" (click)="scroll(commentHistory)">View all Comments<i style="font-size: 15px;margin: 5px;color: #1973d4;cursor: pointer;" class="fa fa-arrow-down" aria-hidden="true"  ></i></span> -->
                            </div>
                          </div>
                          <div id="collapseException" [ngbCollapse]="isCollapsedException" class="tabExceptContent">
                            <h4 class="tabExcept" >
                              <span  *ngIf="isCollapsedCommentHistory" (click)="isCollapsedCommentHistory = !isCollapsedCommentHistory"
                              [attr.aria-expanded]="!isCollapsed" aria-controls="collapseCommentHistory" ><i class="mdi mdi-plus" style="font-weight: bold;cursor: pointer;"></i></span>
                              <span   *ngIf="!isCollapsedCommentHistory" (click)="isCollapsedCommentHistory = !isCollapsedCommentHistory"
                              [attr.aria-expanded]="!isCollapsedCommentHistory" aria-controls="collapseException"><i class="mdi mdi-minus" style="font-weight: bold;cursor: pointer;"></i></span>
                              COMMENT HISTORY
                            </h4>
                            <div id="collapseCommentHistory" [ngbCollapse]="isCollapsedCommentHistory" [ngClass]="{'tabExceptContent-Content-seell': isSeeAll === 'isSee','tabExceptContent-Content': isSeeAll === 'isSeeeee'}"> 
                              <div class="info-list-2 stripe"  *ngFor="let comment of inv?.CommentHistory" style="border: none;">
                                <div class="info-wrapper stripe" style="margin-bottom: 10px;">
                                  <div class="title-header" style="
                                  font-family: 'Roboto';
                                  color: #48484c;
                                  font-weight: 600;
                                  border-right: 1px solid #d6d6d6;">
                                        {{comment?.userCompany}}
                                    </div>
                                    <div class="content" >
                                        <div style="font-size: 14px;" >
                                            {{comment?.userFirstName}}   {{comment?.userinitial}} <span>{{comment?.posteDate | date: 'dd MMM yyyy'}}</span>
                                        </div>
                                        <div  [innerHTML]="comment.userMessage"></div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="stripe" *ngFor="let comment of inv?.CommentHistory">
                              <div  [innerHTML]="comment.userMessage"></div>
                            </div> -->
                    
                            <nz-empty *ngIf="!(inv?.CommentHistory) || inv?.CommentHistory.length == 0"></nz-empty>                     
                              <!-- <span class="gotoBottom" (click)="scroll(commentHistory)">View all Comments<i style="font-size: 15px;margin: 5px;color: #1973d4;cursor: pointer;" class="fa fa-arrow-down" aria-hidden="true"  ></i></span> -->
                            </div>

                            <div *ngIf="seeAllHistory">
                              <span id="collapseCommentHistory"  [ngbCollapse]="isCollapsedCommentHistory"  (click)="seeAllComment()" class="see-all-button">See All</span>
                            </div>
      
                          </div>
                        </div>
                        
        
                   </div>
                   <div nz-row class="infos" nzGutter="12">
                      
                    <div nz-col nzSpan="12">
                        <div class="folder-bg"> <h4 class="tab">
                          <span  *ngIf="isCollapsedExceptionInvoice" (click)="isCollapsedExceptionInvoice = !isCollapsedExceptionInvoice"
                          [attr.aria-expanded]="!isCollapsed" aria-controls="collapseCommentInvoice" ><i class="mdi mdi-plus" style="font-weight: bold;cursor: pointer;"></i></span>
                          <span   *ngIf="!isCollapsedExceptionInvoice" (click)="isCollapsedExceptionInvoice = !isCollapsedExceptionInvoice"
                          [attr.aria-expanded]="!isCollapsedExceptionInvoice" aria-controls="collapseException"><i class="mdi mdi-minus" style="font-weight: bold;cursor: pointer;"></i></span>
                          INVOICE ID'S</h4></div>
                        <div id="collapseCommentInvoice" [ngbCollapse]="isCollapsedExceptionInvoice" style="padding: 10px;background: #ffffff; margin-top: -5px;">
                          <kendo-grid class="invoiceTable" #invoiceTable [data]="inv?.InvoiceIds" [height]="200" >
                              <kendo-grid-column field="Name" title="Field Name" width="50" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                              </kendo-grid-column>
                              <kendo-grid-column field="Value" title="Field Value" width="50" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                              </kendo-grid-column>
                          </kendo-grid>
                        </div>
                    </div>
    
                    <div nz-col nzSpan="12">
                        <div class="folder-bg"><h4 class="tab">
                          <span  *ngIf="isCollapsedExceptionInvoice" (click)="isCollapsedExceptionInvoice = !isCollapsedExceptionInvoice"
                          [attr.aria-expanded]="!isCollapsed" aria-controls="collapseCommentInvoice" ><i class="mdi mdi-plus" style="font-weight: bold;cursor: pointer;"></i></span>
                          <span   *ngIf="!isCollapsedExceptionInvoice" (click)="isCollapsedExceptionInvoice = !isCollapsedExceptionInvoice"
                          [attr.aria-expanded]="!isCollapsedExceptionInvoice" aria-controls="collapseException"><i class="mdi mdi-minus" style="font-weight: bold;cursor: pointer;"></i></span>
                          INVOICE HISTORY</h4></div>
    
                        <div id="collapseCommentInvoice" [ngbCollapse]="isCollapsedExceptionInvoice" style="padding: 10px;background: #ffffff; margin-top: -5px;">
                            <kendo-grid
                            class="invoiceTable"
                            #invoiceTable                 
                            [data]="inv?.InvoiceHistories" 
                            [height]="200" 
                            [resizable]="true">
                                <kendo-grid-column field="HistoryDate" title="Date" width="25" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.HistoryDate | date: 'dd/MMM/yyyy'}}
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="Description" title="Description" width="50" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
                            </kendo-grid>
                        </div>
                    </div>
                    
                </div>                
    
                <div nz-row class="infos">
                  <div class="folder-bg"><h4 class="tab">SHIPMENTS</h4>
                    <button nz-button nzType="default" class="freight-primary export-btn" (click)="exporShipmentData()">Export Shipment Data</button>               
                  </div>
                  
                    <div class="kendoGrid-webres-summary">
                      <div >
                          <kendo-grid           
                          #invoiceTable
                          class="invoiceTable"
                          [data]="shipmentGridView" 
                          [pageSize]="pageSize"
                          [columnMenu]="true"
                          [skip]="skip"
                          [pageable]="true" 
                          [resizable]="true"
                          (pageChange)="pageChange($event)"
                          >
        
                                <kendo-grid-column field="Id" title="Shipment #" width="30" [columnMenu]="true" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                                        {{rowIndex + 1}}
                                    </ng-template>
                                </kendo-grid-column>
        
                                <kendo-grid-column field="Id" title="Shipment Id" width="30" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
        
                                <kendo-grid-column field="OriginCountryCode" title="Origin" width="30" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
                                
                                <kendo-grid-column field="DestinationCountryCode" title="Destination" width="40" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
                                
                                <kendo-grid-column field="ShipmentMode" title="Mode" width="50" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
        
                                <kendo-grid-column field="ShipmentCurrencyCode" title="Currency" width="40" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                </kendo-grid-column>
        
                                <kendo-grid-column  field="BilledAmount" title="Amount" width="40" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                          <span>{{dataItem.BilledAmount |  number : '1.2-2' }} </span>
                                      </ng-template>
                                </kendo-grid-column>
        
                                <kendo-grid-column title="Details" width="20" [columnMenu]="false" [headerStyle]="{ 'background-color': '#0f3f6f', color: '#e8e3e3' }">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <i nz-icon class="details-icon" (click)="showShipmentDetails(dataItem)" nzType="form" nzTheme="outline"></i>
                                    </ng-template>
                                </kendo-grid-column>
                            </kendo-grid>
                        </div>
                    </div>
           
                </div>
                 </div>
            </kendo-splitter-pane>
        
            <kendo-splitter-pane>
                <div class="no-img" #noimg >
                    <img src="/assets/images/alert/No-image-available.png">
                </div>
                <iframe #invoicePDF id="invoicePDFframe" name="invoicePDFframe"  src="" frameborder="0" allowfullscreen > </iframe>
            </kendo-splitter-pane>
        
        </kendo-splitter>
    </div>
    
        <div  class="k-split">
            <div class="shipdata">
                <kendo-window title="Shipment Details" *ngIf="isVisibleShipment" (close)="handleCancel()">
                    <div class="row">
                        <div class="col-md-6">
                        <div style="margin-left: 10px;  width: 500px;">
                            <label style="font-weight: 600;font-family: 'Roboto';">Shipment IDs</label>
                            <kendo-grid #asmple [data]="gridViewInvoiceSIDs" [navigable]="true" [height]="145"
                            [sort]="sortGridInvoiceSIDs" [sortable]="true" (sortChange)="sortChangeInvoiceSIDs($event)">
                            <kendo-grid-column field="Name" title="SID Type" width="50">
                            </kendo-grid-column>
                            <kendo-grid-column field="Value" title="Value" width="50">
                            </kendo-grid-column>
                            </kendo-grid>
                        </div>

                        <div style="margin-left: 10px;
                        background: #e2e2e2;
                        margin-top: 30px;
                        width: 500px;
                        border: 1px solid #b6b7b677;
                        border-radius: 3px;
                        padding: 4px;
                        font-family: 'Roboto';">

                        <div style="display: flex;
                        flex-wrap: wrap;
                        justify-content: space-around;
                        margin-bottom: -10px;">
                          <div>
                            <label style="font-size: 12px;font-family: 'Roboto';
                            font-weight: 600;">Origin</label>
                          </div>
                          <div>
                            <label style="font-size: 12px;font-family: 'Roboto';
                            font-weight: 600;">Destination</label>
                          </div>
                          <div>       
                          <label style="font-size: 12px;font-family: 'Roboto';
                          font-weight: 600;">Shipment Mode </label>
                          </div>
                        </div>
                      
                        <div class="row" style="margin-left: 2px; margin-right: 2px;">
                          <div class="col-md-4" style="padding-top: 4px;border: 1px solid #e2e2e2;padding-left: 5px;padding-right: 1px;background: #fff">
                            <div style="padding:5px;border-radius: 2px;margin-top: -5px;">
                              <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ConsigneeName }}</div>
                              <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.OriginCity }}</div>
                              <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.OriginPostCode }}</div>
                              <img class="flag-big" [src]="getCountryFlag(shipmentInformation?.OriginCountryCode)" alt=""
                                style="width: 30px;" />
                              <div>
                                <span style="font-size: 11px;font-weight: 100"> {{ shipmentInformation?.OriginCountryCode }}</span>
                              </div>
                            </div>
                      
                          </div>
                          <div class="col-md-4" style="padding-top: 4px;border: 1px solid #e2e2e2;padding-left: 1px;padding-right: 1px;background: #fff">
                            <div>
                              <div style="padding:5px;border-radius: 2px;margin-top: -5px;">
                                <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ShipperName }}</div>
                                <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.DestinationCity }}</div>
                                <div style="font-size: 11px;font-weight: 100">{{shipmentInformation?.DestinationPostCode }}</div>
                                <img class="flag-big" [src]="getCountryFlag(shipmentInformation?.DestinationCountryCode)" alt=""
                                  style="width: 30px;" />
                                <div>
                                  <span style="font-size: 11px;font-weight: 100"> {{ shipmentInformation?.DestinationCountryCode
                                    }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4" style="padding-top: 4px;border: 1px solid #e2e2e2;padding-left: 1px;padding-right: 5px;background: #fff">
                            <div>
                                <div style="padding:5px;border-radius: 2px;margin-top: -5px;">
                                <div>
                                  <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ShipmentMode}}</span>
                                </div>
                              </div>
                           
                            </div>
                          </div>
                        </div>
                        </div>                 
                        </div>
                        <div class="col-md-6">
                        <div style=" width: 500px;">
                            <label style="font-weight: 600;
                            font-family: 'Roboto';">Client Fields</label>
                            <kendo-grid #asmple [data]="gridViewInvoiceClientFields" [navigable]="true" [height]="145"
                            [sort]="sortGridClientFields" [sortable]="true" (sortChange)="sortChangeInvoiceClientFields($event)">
                            <kendo-grid-column field="FieldName" title="Field Name" width="50">
                            </kendo-grid-column>
                            <kendo-grid-column field="Value" title="Value" width="50">
                            </kendo-grid-column>
                            </kendo-grid>
                        </div>
                        <div style="background: #e2e2e2;
                        margin-top: 30px;
                        width: 500px;
                        border: 1px solid #b6b7b677;
                        border-radius: 3px;
                        padding: 4px;
                        font-family: 'Roboto';">
                            <div style="display: flex;
                            flex-wrap: wrap;
                            justify-content: space-around;
                            margin-bottom: -10px;">
                              <div>
                                <label style="font-size: 12px;font-family: 'Roboto';
                                font-weight: 600;">Service Type</label>
                              </div>
                              <div>
                                <label style="font-size: 12px;font-family: 'Roboto';
                                font-weight: 600;">Terms</label>
                              </div>
                              <div>       
                              <label style="font-size: 12px;font-family: 'Roboto';
                              font-weight: 600;">Shipment Date</label>
                              </div>
                              <div>       
                                <label style="font-size: 12px;font-family: 'Roboto';
                                font-weight: 600;">Delivery Date </label>
                                </div>
                            </div>
                          
                            <div class="row" style="margin-left: 2px; margin-right: 2px;">
                              <div class="col-md-3" style="padding-top: 4px;border: 1px solid #e2e2e2;padding-left: 5px;padding-right: 1px;background: #fff">
                                  <div style="padding:5px;border-radius: 2px;margin-top: -5px;">
                                    <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ServiceType}}</span>
                                  </div>
                              </div>
                              <div class="col-md-3" style="padding-top: 4px;border: 1px solid #e2e2e2;padding-left: 5px;padding-right: 1px;background: #fff">
                                  <div style="padding:5px;border-radius: 2px;margin-top: -5px;">
                                    <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.FreightTerms}}</span>
                                  </div>
                              </div>
                              <div class="col-md-3" style="padding-top: 4px;border: 1px solid #e2e2e2;padding-left: 5px;padding-right: 1px;background: #fff">
                                  <div style="padding:5px;border-radius: 2px;margin-top: -5px;">
                                    <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.ShipmentDate | date:
                                      'dd/MM/yyyy'}}</span>
                                  </div>
                              </div>
                              <div class="col-md-3" style="padding-top: 4px;border: 1px solid #e2e2e2;padding-left: 5px;padding-right: 1px;background: #fff">
                                  <div style="padding:5px;border-radius: 2px;margin-top: -5px;">
                                    <span style="font-size: 11px;font-weight: 100">{{shipmentInformation?.DeliveryDate | date:
                                      'dd/MM/yyyy'}}</span>
                                  </div>
                              </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-6">
                        <div style="margin-left: 10px;  width: 500px;">
                            <label style="font-weight: 600;
                            font-family: 'Roboto';">Units of Measure</label>
                            <kendo-grid #asmple [data]="gridViewInvoiceUoms" [navigable]="true" [height]="145"
                            [sort]="sortGridInvoiceUoms" [sortable]="true" (sortChange)="sortChangeInvoiceInvoiceUoms($event)">
                            <kendo-grid-column field="UOM.Code" title="UOM Type" width="50">
                            </kendo-grid-column>
                            <kendo-grid-column format={0:n2} field="Amount" title="Invoice Value" width="50">
                            </kendo-grid-column>
                            </kendo-grid>
                        </div>
                        </div>
                        <div class="col-md-6">
                        <div style=" width: 500px;">
                            <label style="font-weight: 600;
                            font-family: 'Roboto';">Charges</label>
                            <kendo-grid #asmple [data]="gridViewInvoiceAccessorials" [navigable]="true" [height]="145"
                            [sort]="sortGridInvoiceAccessorials" [sortable]="true"
                            (sortChange)="sortChangeInvoiceInvoiceAccessorials($event)">
                            <kendo-grid-column field="Code" title="Code" width="50">
                                <ng-template kendoGridFooterTemplate let-column="column">Total
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column format="{0:n2}" field="Amount" title="Amount" width="50">
                                <ng-template kendoGridFooterTemplate let-column="column"> <span>
                                    {{ totalAmount | number : '1.2-2'}}
                                </span></ng-template>
                            </kendo-grid-column>
                            </kendo-grid>
                        </div>
                        </div>
                    </div>
                </kendo-window>
            </div>
    
        </div>
    </div>
    
</div>